import { apiClient } from '@src/clients';
import {
  Chat,
  GetMessageQuery,
  Message,
  RatingType,
  UserMessage
} from '@src/clients/seeker/api';

export const addMessage = async (chatId: Chat['id'], params: UserMessage) => {
  return await apiClient.seekerApi.chats.addMessageChatsChatIdMessagesPost(
    chatId,
    params
  );
};

export const getChatMessages = async (
  id: Chat['id'],
  params: GetMessageQuery = {}
) => {
  return await apiClient.seekerApi.chats.getMessagesChatsChatIdMessagesGet(
    id,
    params
  );
};

export const createNewChat = async () => {
  return await apiClient.seekerApi.chats.createChatChatsPost();
};

export const giveRating = async (
  chatId: Chat['id'],
  messageId: Message['id'],
  rating: RatingType
) => {
  return await apiClient.seekerApi.chats.giveRatingChatsChatIdMessagesMessageIdRatingPut(
    chatId,
    messageId,
    { rating }
  );
};

export const editChatName = async (
  chatId: Chat['id'],
  chatName: Chat['name']
) => {
  return await apiClient.seekerApi.chats.updateChatChatsChatIdPatch(chatId, {
    name: chatName!
  });
};

export const deleteChat = async (chatId: Chat['id']) => {
  return await apiClient.seekerApi.chats.deleteChatChatsChatIdDelete(chatId);
};

export const retryMessage = async (
  chatId: Chat['id'],
  messageId: Message['id'],
  userMessage: UserMessage
) => {
  return await apiClient.seekerApi.chats.regenerateResponseChatsChatIdMessagesMessageIdRetryPost(
    chatId,
    messageId,
    userMessage
  );
};
